angular.module("rjmNg.common.api").factory "GoogleAnalyticsReportValidator", [
  "$q"
  "$timeout"
  "sharedCaches"
  "InputConnections"
  (
    $q
    $timeout
    sharedCaches
    InputConnections
  ) ->

    STATES =
      EMPTY: "EMPTY"
      PENDING: "PENDING"
      INVALID: "INVALID"
      VALID: "VALID"
      ERROR: "ERROR"
      UNAUTHORIZED: "UNAUTHORIZED"
      NO_PROFILE: "NO_PROFILE"
      NO_DATA: "NO_DATA"

    createValidator = (clientId) ->
      cache = {}

      inputConnectionsInstance = InputConnections(clientId)

      getConnectionHash = (metrics, dimensions) ->
        metrics.sort().join(",") + "|" + dimensions.sort().join(",")

      getStateFromResponse = (response) ->
        state = STATES.INVALID
        if response.saw_data and response.has_access
          state = STATES.VALID
        else if response.has_access and not response.saw_data
          state = STATES.NO_DATA
        $q.when state

      saveAndValidate = (id, type, viewId, metrics, dimensions) ->
        testRequest =
          id: viewId
          analytics:
            dimensions: dimensions.map (dimension) ->
              name: dimension
            metrics: metrics.map (metric) ->
              expression: metric

        inputConnectionsInstance.test(id, type, testRequest)
        .then getStateFromResponse
        .catch (error) ->
          if error.status is 401
            $q.when(STATES.UNAUTHORIZED)
          else if error.status is 400 and error.data?
            getStateFromResponse error.data
          else
            $q.when(STATES.ERROR)

      # Returns a promise that's ALWAYS resolved with a value from ``STATES``.
      (connection) ->
        if connection.properties?.metrics?
          metrics = JSON.parse(connection.properties.metrics)
        else
          metrics = []

        if connection.properties?.dimensions?
          dimensions = JSON.parse(connection.properties.dimensions)
        else
          dimensions = []

        hash = getConnectionHash(metrics, dimensions)

        if not connection.properties?.view_id?
          $q.when(STATES.NO_PROFILE)
        else if metrics.length < 1
          $q.when(STATES.EMPTY)
        else if cache[hash]?
          $q.when(cache[hash])
        else
          viewId = connection.properties.view_id
          saveAndValidate(connection.id, connection.type, viewId, metrics, dimensions)
          .then (state) ->
            unless state in [STATES.UNAUTHORIZED, STATES.ERROR]
              cache[hash] = state
            state

    getValidatorInstance = (clientId, appName) ->
      sharedCaches.getSharedObject "gaValidator:#{clientId}:#{appName}", () ->
        createValidator(clientId, appName)

    ###
    Provides a stream of validation events--the ``callback()`` will be invoked
    with a value from ``STATES``.

    Call the ``validate()`` function to run a new validation for the specified
    connection.

    This also provides throttling logic: if multiple calls to ``validate()`` are
    made while a validation request is pending, we'll only run the most recent.
    (So the user doesn't have to wait for a ton of requests for outdated
    connection configurations.)
    ###
    class ValidationStream

      constructor: (clientId, appName, callback) ->
        validationInProgress = false
        nextConnectionToValidate = null
        validator = getValidatorInstance(clientId, appName)

        processQueue = () ->
          validationInProgress = true
          if nextConnectionToValidate?
            connection = nextConnectionToValidate
            nextConnectionToValidate = null
            callback(STATES.PENDING)
            validator(connection).then (state) ->
              callback(state)
              processQueue()
          else
            validationInProgress = false

        @validate = (connection) ->
          nextConnectionToValidate = connection
          unless validationInProgress
            processQueue()

    {
      getValidatorInstance
      ValidationStream
      STATES
    }

]
